
import { useToast } from '@/hooks/use-toast';
import { processWebSearchQueue } from '@/services/webSearchService';

export const useWebSearchQueue = (
  searchStatus: string | null,
  startStatusRefresh: () => void,
  setIsProcessing: (value: boolean) => void,
  leadId?: string
) => {
  const { toast } = useToast();

  const handleProcessQueue = async () => {
    setIsProcessing(true);
    try {
      const result = await processWebSearchQueue({ 
        batchSize: 10, 
        prioritizeLeadId: leadId 
      });
      
      toast({
        title: "Processing queue",
        description: `Processed ${result.processed} leads from the queue.`,
      });
      
      // Always start polling after queue process
      startStatusRefresh();
    } catch (error) {
      console.error('Error processing web search queue:', error);
      
      toast({
        variant: "destructive",
        title: "Failed to process queue",
        description: "An error occurred while processing the web search queue.",
      });
    } finally {
      setIsProcessing(false);
    }
  };

  return { handleProcessQueue };
};
